<template lang="html">
 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 40%; left: 40%;">
                                <img src='../../assets/snakes.gif' /></p>
                        </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">Training List</h4>
          <div style="padding-top:20px;padding-bottom:20px;">  <download-excel
                  class="btn btn-success btn-sm"
                  :data="json_data"
                  :fields="json_fields"
                  name="filename.xls"
                >
                  Download Training List
                </download-excel></div>
            <div class="justify-content-centermy-1 row">
                 <b-form-fieldset horizontal label="Rows per page" class="col-6">
                  <b-form-select :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}]" v-model="perPage">
                  </b-form-select>
                </b-form-fieldset>

                <b-form-fieldset horizontal label="Filter" class="col-6">
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                </b-form-fieldset>
              </div>
                <div class="table-responsive">
              <template>
                <b-table striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" style="font-weight: 200;">
                   <template v-slot:cell(name)="row">
                   {{row.item.user.name}}
                  </template>
                   <template v-slot:cell(phone)="row">{{row.item.user.phone}}</template>
                   <template v-slot:cell(email)="row">{{row.item.user.email}}</template>
                 <template v-slot:cell(_id)="row">
                  <router-link :to="'/pendingrescuerdetails/'+row.item._id ">
                    <b-button variant="success">View Details</b-button>
                  </router-link>
                    </template>
 <!-- <template v-slot:cell(location)="row">
  <router-link :to="'/editrescuers/' + row.item.user._id">Edit</router-link>
</template> -->
                  <template v-slot:cell(status)="row">
  <button class="btn btn-danger" @click="deleteUser(row)">Delete</button>
</template>

                </b-table>
              </template>
              </div>
               <div class="justify-content-center row my-1">
                <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
              </div>
        </div>
     </div>
    </div>
  </div>
  </section>
 </template>
<script lang="js">
import axios from 'axios'
export default {
  name: 'news',
  data () {
    return {
      items: [],
      fields: [
        {
          key: 'name'
        },
        {
          key: 'phone',
          sortable: true
        },
        {
          key: 'email',
          sortable: true
        },
        {
          key: '_id',
          label: 'View Details',
          sortable: true
        },
        {
          key: 'status',
          label: 'Delete'
        }
      ],
      json_fields: {
        'Username': 'user.username',
        'Name': 'user.name',
        'Phone': 'user.phone',
        'Email': 'user.email',
        'Organization': 'user.organization',
        'Adhar Number': 'adharnumber',
        'Blood Group': 'bloodGroup',
        'Disease Details': 'diseaseDetails',
        'Disease Status': 'diseaseStatus',
        'District': 'district',
        'Education': 'education',
        'Type': 'idType',
        'No of Rescues': 'noOfRescues',
        'Offence': 'offence',
        'Offence Details': 'offenceDetails',
        'Permanent Address': 'permanentAddress',
        'Present Address': 'presentAddress',
        'Rescue Started (year)': 'rescueStartedAt',
        'LicenceNumber': 'rescuerCode',

      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      striped: true,
      loading: false
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/rescuer/traininglist',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        if (response.data.status) {
          this.items = response.data.data
          this.json_data = response.data.data
        } else {
          this.items = []
          this.json_data = []
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.items = []
        this.json_data = []
      })
    },
    approve: function (item) {
      var vm = this
      vm.item = item.item._id
      axios({
        method: 'POST',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        url: 'https://sarpatnapi.leopardtechlabs.in/user/activate',
        data: {
          id: vm.item
        }
      }).then(response => {
        alert('Successfully Approved Item')
        this.getList()
      }).catch(e => {
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/forms/traininglist.vue